import script from "./SystemSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemSetting.vue?vue&type=script&setup=true&lang=js"

import "./SystemSetting.vue?vue&type=style&index=0&id=4df6e7ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df6e7ac"]])

export default __exports__